module.exports = __webpack_public_path__ + "static/media/Signature-Image.ca8a6efc.png";